export default "__VITE_ASSET__JI7b11Lx__"